import styled from 'vue-styled-components';

const ItemProps = {
  size: String,
};

const MethodsSkeleton = styled.section`
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  box-sizing: border-box;

  .payment-methods__item {
    background-color: var(--secondary_background_color);
    color: var(--primary_text_color);
    border: var(--border);
    border-radius: var(--border_radius);
    box-shadow: var(--box_shadow);
    border-color: var(--border_color);
    &:hover {
      box-shadow: var(--box_shadow_hover);
      outline: none;
    }
    &:active {
      box-shadow: var(--box_shadow_inset);
      background-color: var(--secondary_background_color);
    }
    &--disabled {
      opacity: 0.3;
      pointer-events: none;
    }

    cursor: pointer;
    pointer-events: none;
    transition: box-shadow 0.3s;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    position: relative;
    padding: 11px;
    margin: 10px 0 10px 20px;
    text-decoration: none;
    box-sizing: border-box;

    .payment-methods__icon-wrap {
      margin-left: auto;
      height: 21px;
      position: absolute;
      top: 10px;
      right: 10px;
      .payment-methods__icon {
        line-height: 1.25;
        padding: 3px 5px 0 4px;
        margin-bottom: 4px;
        border: solid 1px;
      }

      .payment-methods__icon--blue {
        color: #0055cc;
        border-color: rgba(0, 85, 204, 0.25);
      }

      .payment-methods__icon--green {
        color: #13bf4d;
        border-color: rgba(19, 191, 76, 0.25);
      }

      .payment-methods__icon--grey {
        color: #b4b5b8;
        border-color: rgba(215, 217, 220, 0.5);
      }
    }

    .payment-methods__text {
      color: var(--primary_text_color);
      font-size: 14px;
      width: 100%;
    }
  }

  .payment_methods___logo-wrap {
    width: 60%;
    height: 60%;

    .payment-methods__logo {
      width: 100%;
      height: 100%;
    }
  }

  .tooltip {
    display: none;
    top: 0;
    left: 172px;
    top: -10px;
    left: 35px;
  }

  .payment-methods__text {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }

  .payment-methods__icon:hover .tooltip {
    display: block;
  }

  flex-wrap: wrap;

  .method .avatar + .line {
    margin-top: 11px;
    width: 100px;
  }
  .method .line ~ .line {
    background-color: #ddd;
  }
  .method {
    /* background: #d7d9dc; */
    border-radius: 0.4em;
    padding: 11px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
    .icon {
      width: 60%;
      height: 60%;
      border-radius: 0.4em;
      border-radius: 25%;
      background-image: linear-gradient(
        90deg,
        #f4f4f4 0px,
        rgba(229, 229, 229, 0.8) 40px,
        #f4f4f4 80px
      );
      background-size: 600px;
      animation: shine-avatar 2s infinite ease-out;
    }
    .line {
      width: 140px;
      height: 16px;
      border-radius: 7px;
      background-image: linear-gradient(
        90deg,
        #f4f4f4 0px,
        rgba(229, 229, 229, 0.8) 40px,
        #f4f4f4 80px
      );
      background-size: 600px;
      animation: shine-lines 2s infinite ease-out;
    }
  }

  @keyframes shine-lines {
    0% {
      background-position: -100px;
    }
    40%,
    100% {
      background-position: 140px;
    }
  }
  @keyframes shine-avatar {
    0% {
      background-position: -32px;
    }
    40%,
    100% {
      background-position: 208px;
    }
  }
`;

const SkeletonItem = styled('div', ItemProps)`
  overflow: hidden;
  width: ${props => props.size};
  height: ${props => props.size};
`;

MethodsSkeleton.Item = SkeletonItem;

export default MethodsSkeleton;
